const STORAGE_KEY = "fallback_consent";
const BANNER_ID = "fallback-consent-banner";

export const getStoredConsent = () => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
};

const storeConsent = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage unavailable: the choice only lasts for this page view.
  }
};

export const hideConsentBanner = () => {
  document.getElementById(BANNER_ID)?.remove();
};

/**
 * Shows a subtle bottom bar asking for analytics consent.
 * @param {(granted: boolean) => void} onChoice
 */
export const showConsentBanner = (onChoice) => {
  if (document.getElementById(BANNER_ID)) return;

  const banner = document.createElement("div");
  banner.id = BANNER_ID;
  banner.className = "fallback-consent-banner";
  banner.setAttribute("role", "dialog");
  banner.setAttribute("aria-label", "Süti beállítások");

  const text = document.createElement("span");
  text.className = "fallback-consent-text";
  text.textContent = "Az oldal sütiket használ a látogatottság méréséhez és a működés javításához. Részletek: ";

  const createLink = (href, label) => {
    const link = document.createElement("a");
    link.href = href;
    link.textContent = label;
    link.target = "_blank";
    link.rel = "noopener";
    return link;
  };
  text.append(
    createLink("/page/cookie-tajekoztato", "Süti tájékoztató"),
    " · ",
    createLink("/page/adatvedelmi-tajekoztato", "Adatvédelmi tájékoztató")
  );

  const actions = document.createElement("div");
  actions.className = "fallback-consent-actions";

  const decline = document.createElement("button");
  decline.type = "button";
  decline.className = "fallback-consent-button";
  decline.textContent = "Elutasítom";

  const accept = document.createElement("button");
  accept.type = "button";
  accept.className = "fallback-consent-button fallback-consent-accept";
  accept.textContent = "Elfogadom";

  const choose = (granted) => {
    storeConsent(granted ? "granted" : "denied");
    hideConsentBanner();
    onChoice(granted);
  };
  decline.addEventListener("click", () => choose(false));
  accept.addEventListener("click", () => choose(true));

  actions.append(decline, accept);
  banner.append(text, actions);
  document.body.appendChild(banner);
};
